import React from 'react';
import ReactPlayer from 'react-player';

const Scenario5Video4 = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/ji-UR_2PMNQ' controls={true} />
        </div>
    );
}

export default Scenario5Video4;